import { SPLITS_ADDRESS_LABELS } from '~/constants/addresses'
import { HIDDEN_ADDRESS } from '~/store/privacyModeStore'
import { IAddress } from '~/types'
import { Address } from '~/utils/address'
import { shortenAddress, shortenENS } from '~/utils/addresses'

type DisplayNameSources = {
  address?: IAddress
  bankAccountName?: string
  automationName?: string
  smartAccountName?: string
  orgLabel?: string
  ens?: string
  farcasterDisplayName?: string
  farcasterUsername?: string
  payeeOrgName?: string
  payeeEmail?: string
  isTreasury: boolean
  isPrivacyModeOn: boolean
  shouldShortenAddress: boolean
}

// Names the active org gave the address come first, then Splits' names for its
// own addresses, then public and compliance names.
export const resolveDisplayName = ({
  address,
  bankAccountName,
  automationName,
  smartAccountName,
  orgLabel,
  ens,
  farcasterDisplayName,
  farcasterUsername,
  payeeOrgName,
  payeeEmail,
  isTreasury,
  isPrivacyModeOn,
  shouldShortenAddress,
}: DisplayNameSources) => {
  if (!address || !Address.validate(address)) {
    return address
  }

  const name =
    bankAccountName ??
    automationName ??
    smartAccountName ??
    orgLabel ??
    SPLITS_ADDRESS_LABELS[Address.format(address)] ??
    (ens ? shortenENS(ens) : undefined) ??
    farcasterDisplayName ??
    (farcasterUsername ? `@${farcasterUsername}` : undefined) ??
    payeeOrgName ??
    payeeEmail ??
    (isPrivacyModeOn ? HIDDEN_ADDRESS : undefined) ??
    (shouldShortenAddress ? shortenAddress(address) : address)

  return isTreasury ? `${name} ★` : name
}
